module.exports = __webpack_public_path__ + "static/media/chia-work-9.c99d0ac1.jpg";